import { defineComponent } from 'vue';
import SpaceService from '@/entities/space/space.service';
import axios from 'axios';
import { emitter } from '@/shared/event-bus';

export interface StoreSpace {
  id: string;
  name: string;
}

export default defineComponent({
  inject: ['spaceService'],
  data() {
    return {
      spaces: [] as StoreSpace[],
      filters: { selectSpace: '' } as any,
      selectedSpaceId: null as string,
      storeSpace: null as StoreSpace,
      previousSpace: null as StoreSpace,
    };
  },
  watch: {
    '$route.params.spaceId'(spaceId: string): void {
      if (!spaceId || spaceId === 'none' || spaceId === this.selectedSpaceId) {
        return;
      }
      const known = this.spaces.find(s => s.id === spaceId);
      if (!known && this.spaces.length > 0) {
        this.$router.replace({ path: '/', query: { missingSpace: '1' } }).catch(() => {});
        return;
      }
      this.applySpace(known ?? { id: spaceId, name: '' });
    },
  },
  created(): void {
    const urlSpaceId = this.$route.params.spaceId as string;
    const sessionSpace = JSON.parse(sessionStorage.getItem('space')) as StoreSpace;
    this.previousSpace = sessionSpace;

    if (urlSpaceId && urlSpaceId !== 'none') {
      this.applySpace(sessionSpace?.id === urlSpaceId ? sessionSpace : { id: urlSpaceId, name: '' });
    } else if (sessionSpace != null) {
      this.applySpace(sessionSpace);
    }

    this.initRelationships();
    emitter.on('space:updated', this.initRelationships);
  },
  unmounted(): void {
    emitter.off('space:updated', this.initRelationships);
  },
  methods: {
    initRelationships(): void {
      axios.defaults.headers.common.Authorization = 'Bearer ${res.accessToken}';
      (this.spaceService as () => SpaceService)()
        .retrieveAllowSpaces()
        .then(res => {
          this.spaces = res.data.sort((a: StoreSpace, b: StoreSpace) => a.name.localeCompare(b.name));
          if (this.spaces.length === 0) {
            return;
          }

          const urlSpaceId = this.$route.params.spaceId as string;
          if (urlSpaceId && urlSpaceId !== 'none' && !this.spaces.find(s => s.id === urlSpaceId)) {
            const fallback = (this.previousSpace && this.spaces.find(s => s.id === this.previousSpace.id)) || this.spaces[0];
            this.applySpace(fallback);
            this.$router.replace({ path: '/', query: { missingSpace: '1' } }).catch(() => {});
            return;
          }

          const preferredId = (urlSpaceId && urlSpaceId !== 'none' && urlSpaceId) || this.storeSpace?.id;
          this.applySpace((preferredId && this.spaces.find(s => s.id === preferredId)) || this.spaces[0]);
        });
    },
    onChange(): void {
      const target = this.spaces.find(space => space.id === this.selectedSpaceId);
      if (target == null) {
        return;
      }
      this.applySpace(target);

      if (this.$route.params.spaceId && this.$route.params.spaceId !== target.id) {
        const section = this.$route.path.split('/').filter(Boolean)[2] ?? 'statistics';
        this.$router.push(`/space/${target.id}/${section}`).catch(() => {});
      }
    },
    applySpace(space: StoreSpace): void {
      if (space == null) {
        return;
      }
      this.storeSpace = space;
      this.selectedSpaceId = space.id;
      this.$store.commit('space', space);
      sessionStorage.setItem('space', JSON.stringify(space));
    },
  },
});
